import type {LogoProps} from '@livingdata/playground-core-front'

/**
 * Living Data Studio mark — the gradient "S" ribbon, served as an optimized
 * PNG from `public/brand/logo.png`. Decorative: the brand name is exposed
 * separately (sr-only in the sidebar slot, as a wordmark on the splash).
 */
function LivingDataMark({className}: {readonly className?: string}) {
  return (
    <img
      src='/brand/logo.png'
      alt=''
      aria-hidden='true'
      className={className}
    />
  )
}

export function LivingDataLogo({variant}: LogoProps) {
  if (variant === 'compact') {
    return <LivingDataMark className='h-full w-full object-contain p-0.5' />
  }

  return (
    <div className='flex flex-col items-center gap-4'>
      <LivingDataMark className='h-16 w-auto' />
      <span className='text-2xl font-bold tracking-[0.18em] text-[#304358]'>LIVING DATA</span>
    </div>
  )
}
